module.exports = __webpack_public_path__ + "previous-track.svg?5fcd963fbaede98d4e9f095ddbdc46dd";